import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';
import {
  createSingleDelivery,
  handleBatchSend,
  sendTestMailer,
} from './handleMailer';

export const newMailerDefaults = {
  name: '',
  subject: '',
  body: '',
  field_id: '',
  metadata_entry_id: null,
  from: '',
  pdf_body: '',
  landscape: true,
  on_submit: false,
  universal_mail_send: false,
  calendar_event_field_id: null,
};

// allows MailerFieldChooser to remember last used attribute
// ** provide form manually and spread the rest
export const defaultChooserState = {
  category: '',
  fieldsetState: {
    fieldset: {},
    fields: [],
  },
  field: {},
  attributes: [],
  displayNames: {
    fieldsets: false,
    fields: false,
  },
};

export const templateOptions = [
  {
    name: 'fields',
    attributes: [
      'id',
      'name',
      'value',
      'required',
      'placeholder_text',
      'help_text',
      'created_at',
      'updated_at',
    ],
  },
  {
    name: 'form',
    attributes: ['id', 'name', 'description', 'created_at', 'updated_at'],
  },
  {
    name: 'fieldsets',
    attributes: ['id', 'name', 'description', 'created_at', 'updated_at'],
  },
  {
    name: 'submission',
    attributes: ['id', 'created_at', 'updated_at'],
  },
];

export const nonValueTemplateOptions = [
  {
    name: 'fields',
    attributes: [
      'id',
      'name',
      'required',
      'placeholder_text',
      'help_text',
      'created_at',
      'updated_at',
    ],
  },
  {
    name: 'form',
    attributes: ['id', 'name', 'description', 'created_at', 'updated_at'],
  },
  {
    name: 'fieldsets',
    attributes: ['id', 'name', 'description', 'created_at', 'updated_at'],
  },
];

function compileCustomFields(mailMessage) {
  return !mailMessage ? [] : mailMessage.match(/{{custom\..*?}}/gm) || [];
}

const fulfillCustom = (body, pdf_body) => {
  let customBody = compileCustomFields(body);
  let customPdf = compileCustomFields(pdf_body);
  let customInputs = customBody.concat(customPdf);
  let custom_fields = {};
  let customFulfilled = true;
  // takes custom fields found in mailer bodies and assigns values
  customInputs.map((ci) => {
    let ciArray = ci.split('.');
    let type = ciArray[1];
    let name = ciArray[2].replace('}}', '');
    let key = 'custom_' + type + '_' + name;

    let input = window.prompt('Enter mailer ' + type + ' ' + name + ':');

    if (input) {
      custom_fields[key] = input;
    } else {
      customFulfilled = false;
    }
  });
  // customFulfilled defaults to 'true' unless prompt is left blank
  return { custom_fields, customFulfilled };
};

function composeTestMailer(mailer) {
  const { id, body, pdf_body } = mailer;
  const path = '/manage/mailers/' + id + '/test';
  const { custom_fields } = fulfillCustom(body, pdf_body);

  return { path, data: { custom_fields } };
}

export function getToField(toId, altToId, fieldsets, metadata_entries) {
  let fieldset = fieldsets.find((fs) =>
    fs.fields.map((f) => f.id).includes(toId)
  );
  let field = fieldset.fields.find((field) => field.id === toId);
  let metadataEntry, title;
  if (altToId) {
    metadataEntry = metadata_entries.find((me) => me.id === altToId);
  }
  title = metadataEntry ? metadataEntry.title : null;

  return { fieldset: fieldset.fieldset.name, field: field.name, meta: title };
}

export function getCalendarField(calendarFieldId, fieldsets) {
  let fieldset = fieldsets.find((fs) =>
    fs.fields.map((f) => f.id).includes(calendarFieldId)
  );
  if (fieldset) {
    return fieldset.fields.find((field) => field.id === calendarFieldId);
  }
  return null;
}

export function relatedForms(mailer) {
  const { body, pdf_body } = mailer;
  let b = body ? body : '';
  let p = pdf_body ? pdf_body : '';
  let relatedForms = [];

  let matches = b.concat(p).match(/\{\{related_form\.[0-9]+/g);
  if (matches) {
    matches.forEach((m) => {
      relatedForms.push(parseInt(m.replace('{{related_form.', '')));
    });
    relatedForms = [...new Set(relatedForms)];
  }

  return relatedForms;
}

export function handleSendTestMailer(mailer) {
  confirmation.prompt(
    'Test Mailer',
    'Enter Recipient address:',
    '',
    (recipient) => {
      if (!recipient) return;
      // must wait for css animation before calling another prompt...
      var wait = setTimeout(() => {
        confirmation.prompt(
          'BCC Address?',
          'Include BCC (or leave blank):',
          '',
          (bcc) => {
            const { path, data } = composeTestMailer(mailer);
            let testData = { ...data, recipient, bcc };
            sendTestMailer(path, testData);
          }
        );
        clearTimeout(wait);
      }, 301);
    }
  );
}

export const getSingleAddress = (mailer, response, field) => {
  let to = 'No Address Found';
  let mailAlt = mailer.metadata_entry_id;
  let ro, fieldOpt;
  if (response) {
    if (response.response_options[0]) {
      ro = response.response_options[0];
      fieldOpt = field.options.find((o) => o.id == ro.option_id);
    }
    if (mailAlt && ro) {
      // If mailer uses metadata as the recipient...
      let metaValue = fieldOpt.metadata_contents.find(
        (mc) => mc.metadata_entry_id == mailAlt
      );
      to = metaValue ? metaValue.description : to;
    } else if (ro && fieldOpt?.value) {
      // If 'to' field response is option type...
      // !! NOTICE !! Ember architect used option.name as recipient
      // It should technically be value... Need confirmation for this
      to = fieldOpt.value;
    } else if (response.value) {
      // If 'to' field response is text type...
      to = response.value;
    }
  }

  return to;
};

export const getBatchAddresses = async (mailer, filters) => {
  let path = '/manage/submissions/batch_mail';
  let params = { field_id: mailer.field_id, form_id: mailer.form_id };
  if (Object.keys(filters).length) {
    params.filters = filters;
  }

  return axios
    .get(path, { params })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error(err.response);
    });
};

export const sendBatchDeliveries = async (
  mailer,
  count,
  filters,
  closeModal
) => {
  if (!mailer) return;
  let path = '/manage/mailers/' + mailer.id + '/mail';
  const { body, pdf_body } = mailer;

  confirmation.acknowledge(
    //Send
    () => {
      const { custom_fields, customFulfilled } = fulfillCustom(body, pdf_body);
      if (customFulfilled) {
        let params = { custom_fields };
        if (Object.keys(filters).length) {
          params.filters = filters;
        }
        handleBatchSend(path, params, count);
        closeModal();
      } else {
        notify.alertFailure('Mail Cancelled', 'Custom input was left blank.');
      }
    },
    //Cancel
    () => {},
    `Sending to: ${count} recipient(s)`,
    'Are you sure you want to send it?',
    'Send',
    'Cancel'
  );
};

export const sendSingleDelivery = async ({
  mailer,
  subId,
  mailTo,
  bccAddress,
  updateDeliveries,
  alternativeEmail,
  closeModal,
}) => {
  // return early if missing required arguments
  if (!mailer || !subId) return;
  let altPresent = alternativeEmail && alternativeEmail.length > 0;
  // skip the early return if alternativeEmail provided, otherwise check regular mailTo address
  if (!altPresent) {
    if (mailTo == 'No Address Found' || mailTo == '') return;
  }

  const { body, pdf_body } = mailer;

  confirmation.acknowledge(
    //Send
    async () => {
      const { custom_fields, customFulfilled } = fulfillCustom(body, pdf_body);
      let delivery = {
        mailer_id: mailer.id,
        submission_id: subId,
        custom_fields,
        bcc: bccAddress,
      };
      if (altPresent) {
        delivery['alt_address'] = alternativeEmail;
      }

      if (customFulfilled) {
        let delivered = await createSingleDelivery(delivery);
        if (delivered.ok) {
          updateDeliveries(delivered.data);
          closeModal();
        }
      } else {
        notify.alertFailure('Mail Cancelled', 'Custom input was left blank.');
      }
    },
    //Cancel
    () => {},
    `Send Mail`,
    `Are you sure you want to send to: ${
      altPresent ? alternativeEmail : mailTo
    }?`,
    'Send',
    'Cancel'
  );
};

/* Used in Global Search 'forms' table to ensure selected mailer has
  a valid response / address to send to
*/
export const fetchSingleAddress = async (mailer_id, submission_id) => {
  let params = { mailer_id, submission_id };

  return axios
    .get('/manage/deliveries/deliverable', { params })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.error(err.response);
    });
};

const mapModelIdsToNames = (fieldsets) => {
  let mFieldsets = fieldsets.map((fs) => {
    return { [fs.fieldset?.id]: fs.fieldset?.name };
  });
  let fields = fieldsets.flatMap((fs) => fs.fields);
  let mFields = fields.map((f) => {
    return { [f.id]: f.name };
  });
  return { fieldsets: mFieldsets, fields: mFields };
};

/* In mailer preview mode, this replaces the id's of tokens
 * with the name of the field or fieldset in order to give better
 * contextual information to the user.
 */
export const previewTokenNames = (text, fieldsets, related_forms) => {
  if (!text) return '';
  let mappedModelNames = mapModelIdsToNames(fieldsets);
  let previewText = text.replace(
    /\{\{([^}]*\.)?([^}.]*)\}\}/g,
    function (match, modelPart, property) {
      let parts = modelPart ? modelPart.split('.') : [];
      if (parts.length > 1) {
        let model = parts[0];
        let id = parts[1];
        if (mappedModelNames[model]) {
          let token = mappedModelNames[model].find((item) => item[id]);
          if (token) {
            // drop in the field/fieldset name in place of the model id
            return `{{${model}.[${token[id]}].${property}}}`;
          }
        }
      }
      return match; // return the original match if no replacement is found
    }
  );

  if (related_forms && related_forms.length > 0) {
    let relatedTokenPresent = previewText.match(
      /{{(related_form\.[0-9]*)\.([^}]*\.)?([^}.]*)}}/
    );
    if (relatedTokenPresent) {
      let mappedRelatedFormNames = related_forms.map((relatedForm) => {
        return {
          id: relatedForm.form?.id,
          name: relatedForm.form?.name,
          fieldsets: mapModelIdsToNames(relatedForm.fieldsets),
        };
      });

      previewText = previewText.replace(
        /{{(related_form\.[0-9]*)\.([^}]*\.)?([^}.]*)}}/g,
        function (match, formPart, modelPart, property) {
          let parts = modelPart ? modelPart.split('.') : [];
          let relatedForm = mappedRelatedFormNames.find(
            (related) => related.id == formPart.split('.')[1]
          );
          if (relatedForm && parts.length > 1) {
            let model = parts[0];
            switch (model) {
              case 'fieldsets':
              // logic below is executed if 'fieldset' since we omit break;
              case 'fields':
                let id = parts[1];
                if (relatedForm['fieldsets'][model]) {
                  let token = relatedForm['fieldsets'][model].find(
                    (item) => item[id]
                  );
                  // drop in form name and field/fieldset name if available;
                  if (token) {
                    return `{{${relatedForm.name}.${model}.[${token[id]}].${property}}}`;
                  }
                }
                break;
              case 'collect':
                let type = parts[1]; // should be 'list' or 'count_table'
                let fields = parts[2]; // should be 'fields'
                if (
                  !['list', 'count_table'].includes(type) ||
                  fields != 'fields'
                ) {
                  // return early if actual model is not 'fields' or if type does not match
                  return match;
                }
                // reconfigure field ids and properties in order to translate
                let idAndProps = parts
                  .splice(3)
                  .join('.')
                  .concat(property)
                  .split(',');
                let translate = idAndProps.map((idProp) => {
                  let splitIdProp = idProp.split('.');
                  let id = splitIdProp[0];
                  let prop = splitIdProp[1];
                  let token = relatedForm?.fieldsets?.fields?.find(
                    (item) => item[id]
                  );
                  return token ? `[${token[id]}.${prop}]` : 'PARSE ERROR';
                });
                return `{{${relatedForm.name}.COLLECTION.${type}.<br/>${translate.join('<br/>')}}}`;
              case 'form':
                let isMeta = parts[1] == 'meta';
                return `{{${relatedForm.name}.${isMeta ? `meta.${property}` : property}}}`;
              default:
                break;
            }
          }
          return match; // return the original match if no replacement is found
        }
      );
    }
  }

  return previewText;
};
